import { subPurposeChanged } from "../../actions/filters";
import makeSelect from "../../../../shared/make_select";

const valueSelector = (state) => state.filters.subPurpose.selectedValue;
const optionsSelector = (state) => state.filters.subPurpose.options;

export default makeSelect(subPurposeChanged, "Sub-application", valueSelector, optionsSelector, { clearable: true }, { "col-md-3": true });
